import { render, staticRenderFns } from "./End.vue?vue&type=template&id=a872bfcc&scoped=true&"
import script from "./End.vue?vue&type=script&lang=js&"
export * from "./End.vue?vue&type=script&lang=js&"
import style0 from "./End.vue?vue&type=style&index=0&id=a872bfcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a872bfcc",
  null
  
)

export default component.exports